import constants from '../constants/actions';

const initialState = {
    invoiceData: {},
    amendmentInvoice: {},
};

export default function invoiceReducer(state = initialState, action) {
    try {
        const { type = '', payload = {} } = action;
        switch (type) {
            case constants.INVOICE.GET_INVOICE: {
                return {
                    ...state,
                    invoiceData: payload
                };
            }
            case constants.INVOICE.GET_AMENDMENT_INVOICE: {
                return {
                    ...state,
                    amendmentInvoice: payload
                };
            }
            default:
                return state;
        }

    } catch (error) {
        console.log('Invoice Reducer Try catch Error ', error);
        return state;
    }
}
